import "./praktijk.css";
import Seo from "../../components/seo/Seo";

const sections = [
    {
        image: require("../../static/afbeeldingen/meloen-compressed.jpg"),
        alt: "Meloen en gezonde voeding",
        title: "Een passend voedings- en leefstijladvies",
        body: [
            "Of het nu middels vrienden, familie of social media is, we krijgen veel informatie tot ons om aan onze gezondheid te werken.",
            "Maar soms vraagt u zich af of u wel het juiste pad bewandelt.",
            "Bij Vandaag Begin Ik wordt gestreefd naar haalbare doelen op het gebied van voeding, beweging en ontspanning. Eenvoudig en passend in het dagelijks leven.",
            "Genieten van het eten en energie halen uit activiteiten staan voorop.",
        ],
    },
    {
        image: require("../../static/afbeeldingen/qualizorg-compressed.jpg"),
        alt: "Kwaliteit van zorg",
        title: "Qualizorg",
        body: [
            "Het is belangrijk een zo optimaal mogelijke zorg te kunnen verlenen.",
            "Wat vinden de cliënten van de geboden ondersteuning en de toegevoegde waarde in hun kwaliteit van leven?",
            "Dat leest u hier binnenkort.",
        ],
    },
    {
        image: require("../../static/afbeeldingen/Profielfoto-square.png"),
        alt: "Diëtist Rita Wilschut van Vandaag Begin Ik in Breda",
        title: "In contact met Rita",
        imageClassName: "story-card__image story-card__image--portrait",
        body: [
            "Na een groot aantal jaren in het onderwijs en de farmacie te hebben gewerkt zijn wij in 2000 met ons gezin met vier kinderen naar België verhuisd, en vervolgens naar Spanje. Na terugkeer in Nederland in 2010 ben ik gestart met mijn diëtistenpraktijk waarin aanpassing van leefstijl centraal is komen te staan.",
            "Dagelijks zie ik mensen fitter worden, meer energie krijgen en stapjes maken in de richting van een betere balans en een gezondere leefstijl.",
            "Het is belangrijk om het begeleidingstraject van een cliënt aan te passen als de situatie daar om vraagt. Dat is een mooie uitdaging om de gestelde doelen toch te bereiken.",
            "Welkom in mijn praktijk!",
        ],
    },
];

const opleidingen = [
    "Motivational Interviewing",
    "COPD - post HBO",
    "Diabetes Mellitus",
    "Cognitieve Gedragstherapie",
    "Bravo Leefstijlfactoren en Leefstijl coaching",
    "Begeleiding bij Ozempic, Rybelsus & Saxenda",
    "Kanker en de rol van Voeding en Leefstijl",
    "Cardiovasculair Risico Management",
];

export default function Praktijk() {
    return (
        <>
            <Seo
                title="Diëtistenpraktijk Vandaag Begin Ik in Breda"
                description="Lees meer over Rita Wilschut, diëtist en leefstijlcoach in Breda, haar kwalificaties en persoonlijke begeleiding rond voeding en leefstijl."
                path="/praktijk"
            />

            <section className="page-intro">
                <p className="section-label">Praktijk</p>
                <h1>Persoonlijke begeleiding met aandacht voor kwaliteit en vertrouwen.</h1>
                <p>
                    Een praktijk waarin haalbaarheid, deskundigheid en echte aandacht samenkomen.
                </p>
            </section>

            <div className="story-sections">
                {sections.map((section, index) => (
                    <section
                        key={section.title}
                        className={`story-card ${index % 2 === 1 ? "story-card--reverse" : ""}`}
                    >
                        <div className={section.imageClassName || "story-card__image"}>
                            <img src={section.image} alt={section.alt} />
                        </div>
                        <div className="story-card__content">
                            <h2>{section.title}</h2>
                            {section.body.map((paragraph) => (
                                <p key={paragraph}>{paragraph}</p>
                            ))}
                        </div>
                    </section>
                ))}

                <section className="story-card">
                    <div className="story-card__image">
                        <img
                            src={require("../../static/afbeeldingen/chocolade-aarbei-compressed.jpg")}
                            alt="Kwalificaties van diëtist en leefstijlcoach in Breda"
                        />
                    </div>
                    <div className="story-card__content">
                        <h2>Mijn kwalificaties</h2>
                        <p>
                            Na de vierjarige HBO opleiding Voeding &amp; Diëtetiek aan de Haagse
                            Hogeschool heb ik de lerarenopleiding in Delft gevolgd. Voordat
                            ik mijn eigen praktijk startte heb ik de 3 jarige HBO opleiding tot vitaal
                            coach gevolgd en de post-HBO Diëtetiek aan de HVA te Amsterdam afgerond.
                        </p>
                        <p>
                            Om op de hoogte te blijven van de meest recente ontwikkelingen, richtlijnen
                            en protocollen volg ik ieder jaar diverse bij- en nascholingen en is er
                            maandelijks casuïstiekbespreking in een intervisiegroep met collega
                            diëtisten.
                        </p>
                        <p>
                            Om kwaliteit te garanderen sta ik ingeschreven in het Kwaliteitsregister
                            Paramedici en ben ik lid van de Diëtisten Coöperatie Nederland (DCN).
                        </p>

                        <ul className="expertise-list">
                            {opleidingen.map((opleiding) => (
                                <li key={opleiding}>{opleiding}</li>
                            ))}
                        </ul>
                    </div>
                </section>
            </div>
        </>
    );
}
